import { Components } from '@mui/material'

import Fonts from '#/styles/Fonts'

export function OverridedTable(): Components {
  return {
    MuiTablePagination: {
      styleOverrides: {
        root: {
          fontSize: Fonts.fontSize.S,
        },
        toolbar: {
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
        },
      },
    },
  }
}
